module.exports = __webpack_public_path__ + "img/footer-bg.9509c1ef.jpg";